// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__4Qsij","main":"contact_main__WyWvi","title":"contact_title__+YHLt","ignoreConvert":"contact_ignoreConvert__x4+T3","rotate":"contact_rotate__sT79Q"};